import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import NotificationsIcon from '@material-ui/icons/Notifications';

import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useSnackbarContext } from 'Context/SnackbarContext';
import Alert from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Alert';
import AlertTitle from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/AlertTitle';
import Snackbar from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Snackbar';
import Icon from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Icon';
import { dataAttrs } from 'Helpers/Testing';

const styles = theme => ({
  root: {},
  alertRoot: {
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.radius.md,
    display: 'flex',
    alignItems: 'center',
  },
  alertMessage: {
    ...theme.typography.h6,
    color: theme.palette.facet.primaryGray,
  },
  alertTitle: {
    color: theme.palette.facet.primaryBlue,
    fontWeight: theme.typography.fontWeightBold,
  },
  icon: {
    padding: theme.spacing(1),
    fontSize: '2.5rem',
  },
});

const SnackbarItem = ({
  className,
  classes,
  item,
}) => {
  const { handleCloseItem } = useSnackbarContext();

  return (
    <Snackbar
      className={classNames(classes.root, className)}
      open={item.open}
      autoHideDuration={item.timeout}
      onClose={() => handleCloseItem(item)}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        classes={{
          root: classes.alertRoot,
          message: classes.alertMessage,
        }}
        iconMapping={{
          error: (<Icon
            className={classes.icon}
            fill={'red'}
            icon={ErrorIcon}
            showBackground
            {...dataAttrs('snackbar-error-icon')}
          />),
          success: (<Icon
            className={classes.icon}
            fill={'secondary'}
            icon={CheckCircleIcon}
            showBackground
          />),
          info: (<Icon
            className={classes.icon}
            fill={'primary'}
            icon={NotificationsIcon}
            showBackground
          />),
          warning: (<Icon
            className={classes.icon}
            fill={'orange'}
            icon={ErrorIcon}
            showBackground
          />),
        }}
        onClose={() => handleCloseItem(item)}
        severity={item.type}
        test={'snack-bar-alert'}
        elevation={2}
      >
        {item.title ? (
          <AlertTitle
            className={classes.alertTitle}
            variant={'h5'}
          >
            {item.title}
          </AlertTitle>
        ) : null}
        {item.message}
      </Alert>
    </Snackbar>
  );
};

SnackbarItem.defaultProps = {
  className: '',
};

SnackbarItem.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
};

export default withStyles(styles)(SnackbarItem);
